module.exports = __webpack_public_path__ + "img/gztsg.dd504854.png";